import { CreateThreadWithMessageMutationVariables } from "src/state/gql/_types"
import { FormSchema } from "src/utils/forms"

export type SuperAdminThreadCreateFragment = CreateThreadWithMessageMutationVariables

export const SuperAdminThreadCreateSchema: FormSchema<SuperAdminThreadCreateFragment> = {
    id: "thread",
    title: "Thread",
    groups: {
        default: {
            label: 'Default' 
        }
    },
    fields: {
        recipient_ids: {
            group: 'details',
            label: "Recipient IDs",
            type: "add-thread-recipients",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        subject: {
            group: 'details',
            label: "Subject",
            type: "text",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        body: {
            group: 'details',
            label: "Body",
            type: "textarea",
            grid: 12,
            validation: {
                type: {
                    value: "string",
                    message: "{field} must be a string"
                },
                required: {
                    value: true,
                    message: "{field} is required"
                }
            }
        },
        // departments: {
        //     group: 'details',
        //     label: "Departments",
        //     type: "textarea",
        //     grid: 12,
        //     validation: {
        //         type: {
        //             value: "string",
        //             message: "{field} must be a string"
        //         },
        //         required: {
        //             value: false,
        //             message: "{field} is required"
        //         }
        //     }
        // },
    }
}